import React from "react";
import { shirtImageOptions } from "../../data/image-options";
import StylePicker from "./StylePicker";

const ShirtImageDropdown = ({ formik }) => (
  <StylePicker
    options={shirtImageOptions}
    value={formik.values.customer.shirt.image}
    onChange={(key) => formik.setFieldValue("customer.shirt.image", key)}
  />
);

export default ShirtImageDropdown;
